import { createContext, useContext, ReactNode, useState } from 'react';

interface WorkordersMapContextValue {
  hoveredWorkorderId: number | null;
  setHoveredWorkorderId: (id: number | null) => void;
}

const WorkordersMapContext = createContext<WorkordersMapContextValue | null>(
  null,
);

export function useWorkordersMapContext(): WorkordersMapContextValue {
  const context = useContext(WorkordersMapContext);
  if (!context) {
    throw new Error(
      'useWorkordersMapContext must be used within WorkordersMapProvider',
    );
  }
  return context;
}

interface WorkordersMapProviderProps {
  children: ReactNode;
}

export function WorkordersMapProvider({
  children,
}: WorkordersMapProviderProps) {
  const [hoveredWorkorderId, setHoveredWorkorderId] = useState<number | null>(
    null,
  );

  return (
    <WorkordersMapContext.Provider
      value={{ hoveredWorkorderId, setHoveredWorkorderId }}
    >
      {children}
    </WorkordersMapContext.Provider>
  );
}
